module.exports = __webpack_public_path__ + "assets/img/bg-02.6e608ff7.png";